/** Mock active approval rules for the Approval Designer (until tenant REST is wired). */

export const MOCK_APPROVAL_RULES = [
  {
    id: 'rule-salary-15',
    name: 'Salary increase over 15%',
    transaction: 'Compensation',
    status: 'active',
    summary: 'Route large salary changes to manager, then HR VP group.',
    design: {
      summary: 'Salary increase > 15% requires manager and HR VP approval.',
      transactionHint: 'Compensation',
      conditions: [
        {
          description: 'Salary change percentage is greater than 15%',
          attribute: 'SALARY_CHANGE_PCT',
          operator: 'gt',
          value: '15',
        },
      ],
      stages: [
        {
          order: 1,
          routing: 'sequential',
          label: 'Line manager',
          approvers: [{ kind: 'lineManager', ref: 'n/a' }],
        },
        {
          order: 2,
          routing: 'sequential',
          label: 'HR leadership',
          approvers: [{ kind: 'approvalGroup', ref: 'HR VP Approval Group' }],
        },
      ],
      elseAction: { routing: 'autoApprove', stages: [] },
    },
  },
  {
    id: 'rule-absence-5d',
    name: 'Absence over 5 days',
    transaction: 'Absence',
    status: 'active',
    summary: 'Extended absences route through manager and department head.',
    design: {
      summary: 'Absences longer than 5 business days need dual approval.',
      transactionHint: 'Absence',
      conditions: [
        {
          description: 'Absence duration exceeds 5 business days',
          attribute: 'ABSENCE_DAYS',
          operator: 'gt',
          value: '5',
        },
      ],
      stages: [
        {
          order: 1,
          routing: 'sequential',
          label: 'Management hierarchy',
          approvers: [{ kind: 'position', ref: 'Department Head' }],
        },
        {
          order: 2,
          routing: 'parallel',
          label: 'HR & payroll',
          approvers: [
            { kind: 'approvalGroup', ref: 'HR Operations' },
            { kind: 'applicationRole', ref: 'Payroll Administrator' },
          ],
        },
      ],
      elseAction: { routing: 'autoApprove', stages: [] },
    },
  },
  {
    id: 'rule-promotion',
    name: 'Promotion approval',
    transaction: 'Talent',
    status: 'active',
    summary: 'All promotions require compensation committee review.',
    design: {
      summary: 'Promotion transactions route to manager then compensation committee.',
      transactionHint: 'Promotion',
      conditions: [{ description: 'Transaction type is promotion' }],
      stages: [
        {
          order: 1,
          routing: 'sequential',
          approvers: [{ kind: 'lineManager', ref: 'n/a' }],
        },
        {
          order: 2,
          routing: 'sequential',
          approvers: [{ kind: 'approvalGroup', ref: 'Compensation Committee' }],
        },
      ],
      elseAction: { routing: 'autoApprove', stages: [] },
    },
  },
  {
    id: 'rule-timecard',
    name: 'Time card exception',
    transaction: 'Time & Labor',
    status: 'active',
    summary: 'Overtime exceptions auto-approve under threshold.',
    design: {
      summary: 'Small overtime adjustments auto-approve; larger ones need manager.',
      transactionHint: 'Timecard',
      conditions: [
        {
          description: 'Overtime hours exceed 8 in a week',
          attribute: 'OT_HOURS',
          operator: 'gt',
          value: '8',
        },
      ],
      stages: [
        {
          order: 1,
          routing: 'sequential',
          approvers: [{ kind: 'lineManager', ref: 'n/a' }],
        },
      ],
      elseAction: { routing: 'autoApprove', stages: [] },
    },
  },
];

/** Mock autocomplete values keyed by approver kind. */
export const MOCK_APPROVER_SUGGESTIONS = {
  lineManager: ['Direct manager', 'Skip-level manager', 'Department head', 'n/a'],
  user: ['jane.doe', 'john.smith', 'maria.garcia', 'hr.admin'],
  approvalGroup: [
    'HR VP Approval Group',
    'Compensation Committee',
    'HR Operations',
    'Finance Reviewers',
    'Payroll Approvers',
  ],
  position: ['Director', 'VP Operations', 'Department Head', 'CFO', 'Regional Manager'],
  applicationRole: [
    'Compensation Manager',
    'HR Specialist',
    'Payroll Administrator',
    'Benefits Administrator',
  ],
  autoApprove: ['n/a'],
};

export const APPROVER_TYPE_OPTIONS = [
  { value: 'lineManager', label: 'Management Hierarchy' },
  { value: 'approvalGroup', label: 'Approval Group' },
  { value: 'user', label: 'Named User' },
  { value: 'position', label: 'Job Level / Position' },
  { value: 'applicationRole', label: 'Application Role (AOR)' },
  { value: 'autoApprove', label: 'Auto Approve' },
];
